module.exports = __webpack_public_path__ + "img/BCC.fa125904.svg";